let isChecked = JSON.parse(localStorage.getItem("priceToggleState")) ?? true;
let initialLoad = true;

const formatPrice = (price, isTTC) => {
    const formattedPrice = (price / 100).toLocaleString("fr-FR", {
        style: "currency",
        currency: "EUR",
        minimumFractionDigits: 2
    });
    return isTTC ? `${formattedPrice} HT` : `${formattedPrice} TTC`;
};

const getPriceElements = () => document.querySelectorAll(".price-item, .price-item--regular, .price-item--sale, .product__price-varies.price.price--large, .price--end, .price__badge, .badge--bottom-left");

const getTotalPriceElement = () => document.querySelector(".header__cart-total__price");

const initializeOriginalPrice = (element) => {
    if (!element || !element.textContent) return;

    if (!element.hasAttribute("data-original-price")) {
        const text = element.textContent.trim();
        const hasFromPrefix = text.includes("Du ") || text.includes("À partir de");
        // Nettoyer le texte pour ne garder que les chiffres
        const cleanedText = text
            .replace(/Du\s+/g, "")
            .replace(/à partir de\s+/g, "")
            .replace(/[^\d]/g, "");
        element.setAttribute("data-original-price", cleanedText);
        if (hasFromPrefix) {
            element.setAttribute("data-has-from-prefix", "true");
        }
    }
};

const getDisplayedPrice = (price, isTTC) => {
    const priceFloat = parseFloat(price);
    if (isNaN(priceFloat)) return 0;
    return isTTC ? priceFloat : Math.round(priceFloat / 1.2);
};

const updatePriceText = (element, price, isTTC) => {
    const hasFromPrefix = element.hasAttribute("data-has-from-prefix");
    const formattedPrice = formatPrice(price, !isTTC);
    element.textContent = hasFromPrefix ? `À partir de ${formattedPrice}` : formattedPrice;
};

const updateIntitule = (isTTC) => {
    const intituleElement = document.getElementById("intitule");
    if (intituleElement) {
        intituleElement.innerHTML = `<strong>${isTTC ? "TTC" : "HT"}</strong>`;
    }
};

const updatePrices = () => {
    const priceElements = document.querySelectorAll(".price-item, .price-item--regular, .price-item--sale, .product__price-varies.price.price--large, .price--end, .price__badge, .badge--bottom-left");
    const totalPriceElement = document.querySelector(".header__cart-total__price");

    // Initialiser et mettre à jour le prix du panier (si il existe)
    if (totalPriceElement) {
        initializeOriginalPrice(totalPriceElement);
        const totalOriginalPrice = totalPriceElement.getAttribute("data-original-price");
        if (totalOriginalPrice) {
            const totalDisplayedPrice = getDisplayedPrice(totalOriginalPrice, isChecked);
            updatePriceText(totalPriceElement, totalDisplayedPrice, isChecked);
        }
    }

    priceElements.forEach(element => {
        if (!initialLoad && element.classList.contains("product__price-varies")) return;

        // Initialiser chaque prix
        initializeOriginalPrice(element);

        const originalPrice = element.getAttribute("data-original-price");
        if (originalPrice) {
            const displayedPrice = getDisplayedPrice(originalPrice, isChecked);
            updatePriceText(element, displayedPrice, isChecked);
        }
    });

    updateIntitule(isChecked);
};

const debounceFunction = (func, delay) => {
    let timeout;
    return (...args) => {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), delay);
    };
};

const debouncedUpdatePrices = debounceFunction(updatePrices, 200);

const toggleTax = () => {
    isChecked = !isChecked;
    localStorage.setItem("priceToggleState", JSON.stringify(isChecked));
    updatePrices();
    updateVariantDisplayedPrice();
};

const updateVariantDisplayedPrice = () => {
    const hiddenInput = document.querySelector('input[name="id"][type="hidden"]');
    const hiddenInputValue = hiddenInput ? hiddenInput.value : null;

    if (!productInfo || !hiddenInputValue) {
        console.log("updateVariantDisplayedPrice : productInfo ou hiddenInputValue manquant");
        return;
    }

    const variant = productInfo.variants.find(v => v.id == hiddenInputValue);

    if (variant) {
        const displayedPrice = isChecked ? variant.price : Math.round(variant.price / 1.2);

        // Chercher les structures de prix
        let priceContainer = document.querySelector(".price__sale-container");
        const priceSaleDiv = document.querySelector(".price__sale");
        let priceElement = priceContainer ? priceContainer.querySelector(".product__price-varies") : document.querySelector(".product__price-varies");

        if (!priceElement) {
            priceElement = document.querySelector(".price-item--sale");
        }

        // Si la variante a un compare_at_price supérieur au prix
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            const displayedCompareAtPrice = isChecked ? variant.compare_at_price : Math.round(variant.compare_at_price / 1.2);

            // Cas 1 : Structure .price__sale existe (snippet price.liquid)
            if (priceSaleDiv && !priceContainer) {
                let compareAtPriceElement = priceSaleDiv.querySelector('s.price-item--regular');
                if (compareAtPriceElement) {
                    compareAtPriceElement.textContent = formatPrice(displayedCompareAtPrice, !isChecked);
                    compareAtPriceElement.setAttribute("data-original-price", displayedCompareAtPrice);
                }
                // Mettre à jour le prix actuel
                let salePrice = priceSaleDiv.querySelector('.price-item--sale');
                if (salePrice) {
                    salePrice.textContent = formatPrice(displayedPrice, !isChecked);
                    salePrice.setAttribute("data-original-price", displayedPrice);
                }
            }
            // Cas 2 : Structure .price__sale-container existe déjà
            else if (priceContainer && priceElement) {
                let compareAtPriceElement = priceContainer.querySelector('s.price-item--regular');

                if (compareAtPriceElement) {
                    // Le prix barré existe, on le met à jour et on le montre
                    compareAtPriceElement.textContent = formatPrice(displayedCompareAtPrice, !isChecked);
                    compareAtPriceElement.setAttribute("data-original-price", displayedCompareAtPrice);
                    compareAtPriceElement.style.display = 'block';
                } else {
                    // Le prix barré n'existe pas, on le crée
                    compareAtPriceElement = document.createElement('s');
                    compareAtPriceElement.className = 'price-item price-item--regular';
                    compareAtPriceElement.setAttribute('data-original-price', displayedCompareAtPrice);
                    compareAtPriceElement.style.cssText = 'text-decoration: line-through; font-size: 1.8rem; color: rgb(var(--color-compare-at-price)); display: block; margin-bottom: 0.5rem;';
                    compareAtPriceElement.textContent = formatPrice(displayedCompareAtPrice, !isChecked);
                    priceContainer.insertBefore(compareAtPriceElement, priceElement);
                }

                // Mettre à jour le prix actuel
                priceElement.textContent = formatPrice(displayedPrice, !isChecked);
                priceElement.setAttribute("data-original-price", displayedPrice);
                priceElement.style.cssText = 'color: rgb(var(--color-sale-off-price)); font-weight: var(--font-body-weight-medium);';
            }
            // Cas 3 : Aucune structure n'existe, on crée .price__sale-container
            else if (priceElement) {
                const container = document.createElement('div');
                container.className = 'price__sale-container';

                const compareElement = document.createElement('s');
                compareElement.className = 'price-item price-item--regular';
                compareElement.setAttribute('data-original-price', displayedCompareAtPrice);
                compareElement.style.cssText = 'text-decoration: line-through; font-size: 1.8rem; color: rgb(var(--color-compare-at-price)); display: block; margin-bottom: 0.5rem;';
                compareElement.textContent = formatPrice(displayedCompareAtPrice, !isChecked);

                container.appendChild(compareElement);
                priceElement.parentNode.insertBefore(container, priceElement);
                container.appendChild(priceElement);
                priceElement.style.cssText = 'color: rgb(var(--color-sale-off-price)); font-weight: var(--font-body-weight-medium);';

                // Mettre à jour le prix actuel
                priceElement.textContent = formatPrice(displayedPrice, !isChecked);
                priceElement.setAttribute("data-original-price", displayedPrice);
            }
        } else {
            // Pas de compare_at_price - on cache juste le prix barré au lieu de tout détruire
            if (priceContainer) {
                let compareElement = priceContainer.querySelector('s.price-item--regular');
                if (compareElement) {
                    compareElement.style.display = 'none';
                }

                // Réinitialiser le style du prix actuel
                if (priceElement) {
                    priceElement.style.cssText = '';
                }
            }

            // Mettre à jour le prix actuel (fonctionne pour toutes les structures)
            if (priceElement) {
                priceElement.textContent = formatPrice(displayedPrice, !isChecked);
                priceElement.setAttribute("data-original-price", displayedPrice);
            } else {
                console.log("updateVariantDisplayedPrice : priceElement non trouvé");
            }
        }
    } else {
        console.log(`updateVariantDisplayedPrice : Aucun variant trouvé avec l'ID: ${hiddenInputValue}`);
    }
};

const availableVariant = () => {
    const hiddenInput = document.querySelector('input[name="id"][type="hidden"]');
    const messageVariant = document.querySelector("#message-variant");
    const hiddenInputValue = hiddenInput ? hiddenInput.value : null;

    if (!productInfo) return;

    const variant = productInfo.variants.find(v => v.id == hiddenInputValue);

    if (messageVariant && variant) {
        messageVariant.style.display = variant.available ? "none" : "block";
    } else {
        console.log(`availableVariant : No variant found with ID: ${hiddenInputValue}`);
    }
};

const observeHiddenInput = () => {
    const hiddenInput = document.querySelector('input[name="id"][type="hidden"]');
    if (hiddenInput) {
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.type === "attributes" && mutation.attributeName === "value") {
                    updateVariantDisplayedPrice();
                    availableVariant();
                }
            });
        });
        observer.observe(hiddenInput, { attributes: true });
    }
};

function initializePriceToggle() {
    const priceToggle = document.querySelector("#price-toggle");
    if (priceToggle) {
        priceToggle.checked = isChecked;
        priceToggle.addEventListener("change", toggleTax);
    }
}

function observeElements(selectors, callback) {
    const elements = document.querySelectorAll(selectors.join(", "));
    const observer = createObserver(callback);
    elements.forEach((element) => {
        if (element) {
            observer.observe(element, { childList: true, subtree: true, characterData: true });
        } else {
            console.error("Élément à observer non trouvé pour les sélecteurs:", selectors);
        }
    });
}

function observeElement(selector, callback) {
    const element = document.querySelector(selector);
    if (element) {
        createObserver(callback).observe(element, { childList: true, subtree: true, characterData: true });
    } else {
        console.error("Élément à observer non trouvé pour le sélecteur:", selector);
    }
}

function createObserver(callback) {
    return new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.type === "childList" || mutation.type === "characterData") {
                callback();
            }
        });
    });
}

document.addEventListener("DOMContentLoaded", () => {
    const debouncedUpdate = debounceFunction(updatePrices, 200);

    updatePrices();
    initialLoad = false;
    updateVariantDisplayedPrice();
    availableVariant();
    initializePriceToggle();

    observeElements([".product-recommendations", ".recently-viewed-products__section, .cart__recommendation-list"], debouncedUpdate);
    observeElement("#ProductGridContainer", debouncedUpdate);
    observeHiddenInput();

    // Search functionality
    const searchInput = document.querySelector("#Search-In-Inline");
    const searchButton = document.querySelector(".search__button");

    searchInput.addEventListener("keydown", (e) => {
        if ((e.key === "Enter" || e.keyCode === 13) && searchInput.value.trim() === "") {
            e.preventDefault();
        }
    });

    searchButton.addEventListener("click", (e) => {
        if (searchInput.value.trim() === "") {
            e.preventDefault();
        }
    });

    // Popup functionality
    const popupContainer = document.getElementById("popup-container");
    const popupClose = document.querySelector(".popup-close");
    if (!popupContainer) return;
    const popupShownDate = localStorage.getItem("popup_shown_date");
    const currentTime = Date.now();

    if (!popupShownDate || currentTime - parseInt(popupShownDate) >= 604800000) {
        popupContainer.classList.add("popup-visible");
        localStorage.setItem("popup_shown_date", currentTime.toString());
    }

    popupClose.addEventListener("click", function() {
        popupContainer.classList.remove("popup-visible");
    });

    // Newsletter form
    const newsletterForm = document.getElementById("popup-newsletter-form");
    const feedback = document.getElementById("popup-feedback");

    newsletterForm.addEventListener("submit", function(e) {
        e.preventDefault();
        const email = document.getElementById("popup-email").value;

        if (!email || !email.includes("@")) {
            feedback.style.display = "block";
            feedback.style.color = "red";
            feedback.textContent = "Veuillez entrer une adresse email valide.";
            return;
        }

        fetch("https://newsletter.creaddictive.fr/subscribe", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            credentials: "include",
            body: JSON.stringify({ email: email })
        })
        .then(async (response) => {
            if (!response.ok) {
                const error = await response.json();
                throw new Error(error.message || "Erreur serveur");
            }
            return response.json();
        })
        .then((data) => {
            feedback.style.display = "block";
            if (data.alreadySubscribed) {
                feedback.style.color = "orange";
                feedback.textContent = data.message;
            } else {
                feedback.style.color = "green";
                feedback.textContent = data.message;
            }
            newsletterForm.reset();
        })
        .catch((error) => {
            console.error("Détails de l'erreur:", error);
            feedback.style.display = "block";
            feedback.style.color = "red";
            feedback.textContent = `Erreur : ${error.message}`;
        });
    });
});
